import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const SectionTitle = styled.h3`
  margin-bottom: 32px;
  font-weight: 600;
  line-height: 1.13;
  letter-spacing: -0.5px;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;
